import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="footer-inner">
        <div>
          <svg width="130" height="36" viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg">
            <line x1="60" y1="18" x2="204" y2="18" stroke="#5aaa1a" strokeWidth="4" strokeLinecap="round"/>
            <line x1="80" y1="12" x2="204" y2="12" stroke="#5aaa1a" strokeWidth="3" strokeLinecap="round"/>
            <circle cx="220" cy="14" r="12" fill="white"/>
            <text x="0" y="70" fontFamily="Barlow Condensed, sans-serif" fontWeight="900" fontSize="38" fill="white">RUSH</text>
            <text x="88" y="70" fontFamily="Barlow Condensed, sans-serif" fontWeight="900" fontSize="38" fill="#5aaa1a">PUTT</text>
          </svg>
        </div>
        <ul className="footer-links">
          <li><a href="#about">About</a></li>
          <li><a href="#how">How It Works</a></li>
          <li><a href="#leaderboard">Leaderboards</a></li>
          <li><a href="#callback">Contact</a></li>
        </ul>
        <p className="footer-copy">&copy; 2026 RushPutt. All rights reserved.</p>
      </div>
    </footer>
  );
}
